import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { CdsInputTypes } from '@cds/ng-core/textfield';
import { CdsTextfieldModule } from '@cds/ng-web-components/textfield';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-cd-textfield',
  templateUrl: './cd-textfield.component.html',
  styleUrls: ['./cd-textfield.component.scss'],
  imports: [CdsTextfieldModule, NgClass, FormsModule, ReactiveFormsModule],
})
export class CdTextfieldComponent implements OnInit {
  @Input() placeholder = '';
  @Input() disable = false;
  @Input() formControl!: FormControl;
  @Input() type: CdsInputTypes = 'text';

  constructor() {}

  ngOnInit(): void {}
}
